import { render, staticRenderFns } from "./administrators.vue?vue&type=template&id=2f909c1a&scoped=true"
import script from "./administrators.vue?vue&type=script&lang=js"
export * from "./administrators.vue?vue&type=script&lang=js"
import style0 from "./administrators.vue?vue&type=style&index=0&id=2f909c1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f909c1a",
  null
  
)

export default component.exports